import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ExpandingArticleModule } from '../../notes/expanding-article/expanding-article.module';

import { FaqTopicsComponent } from './faq-topics.component';

@NgModule({
  declarations: [FaqTopicsComponent],
  imports: [CommonModule, ExpandingArticleModule],
  exports: [FaqTopicsComponent],
})
export class FaqTopicsModule {}
